import { jsx } from 'panel';
import { EntryType, GroupEventBehaviors, RowLabelType, RowPrefixBehaviors } from 'common/widgets/query-entry-section/types';
import { hasNewQBUI } from 'common/widgets/query-builder/util';
import { QueryEntrySectionEl } from '../base/query-entry-section-el';
import { BaseEntryRowEl } from '../base/template';
/**
 * QueryGroupedEntryRow renders a grouped event row (nested events)
 */

export function GroupedEntryRowEl(_ref) {
  let {
    section,
    entry,
    index
  } = _ref;
  const hasNewUI = hasNewQBUI();
  const nestedSection = jsx(QueryEntrySectionEl, {
    class: {
      'contained-section': hasNewUI,
      'indent-filters': hasNewUI
    },
    attrs: Object.assign(Object.assign({}, section.helpers.getNestedSectionAttrs()), {
      'entry-type': EntryType.Event,
      elref: "subEntry",
      // the new UI does not nest labels
      'row-label-prefix': !hasNewUI && section.helpers.getRowLabel(index),
      'row-label-prefix-behavior': !hasNewUI && RowPrefixBehaviors.FirstOnly,
      'row-label-type': RowLabelType.Alpha,
      'row-index': index,
      'row-index-toggleable': !hasNewUI && section.attr("row-index-toggleable"),
      'row-draggable': true,
      'group-event-behavior': GroupEventBehaviors.Append,
      entries: entry.event
    }),
    on: {
      update: ev => section.helpers.onGroupedSectionUpdate(index, ev),
      dropIntoGroup: section.helpers.onEntryStepDropIntoGroup,
      entryIndexLabelClicked: () => section.helpers.onEntryIndexLabelClicked(index)
    }
  });

  if (hasNewUI) {
    return jsx(BaseEntryRowEl, {
      index: index,
      el: section,
      entry: entry,
      hideActions: true,
      rowRenderer: {
        prefixRenderer: null,
        selectorRenderer: () => nestedSection,
        bodyRowRenderer: null,
        suffixRenderer: null
      },
      isPlaceholder: this.isPlaceholder()
    });
  }

  return nestedSection;
}